import Reveal from "./Reveal";

const IMG_A =
  "https://customer-assets-lqy194kg.emergentagent.net/job_design-refresh-642/artifacts/axr5gkjl_Image%20A.jpg";

const stats = [
  { value: "35 M", label: "de foyers en électricité en France (≈ 10 M en gaz)", amber: false },
  { value: "1 foyer sur 3", label: "a déjà quitté l'opérateur historique (près d'1 sur 2 en gaz)", amber: false },
  { value: "+556 000", label: "foyers passés à un fournisseur alternatif en 2025", amber: true },
];

export default function Marche() {
  return (
    <section id="marche" data-testid="marche-section" className="relative py-28 md:py-36 border-t border-emerald-400/10 overflow-hidden">
      <div className="absolute top-0 right-0 w-[500px] h-[500px] rounded-full bg-amber-500/5 blur-[140px] pointer-events-none" />
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-14 items-center mb-16 md:mb-20">
          <Reveal>
            <p className="font-jbmono text-xs uppercase tracking-[0.3em] text-emerald-400 mb-6">01 — Le marché</p>
            <h2 className="font-display font-bold tracking-tight leading-tight text-3xl sm:text-4xl lg:text-5xl">
              Un marché de masse,
              <span className="text-emerald-400"> en pleine bascule.</span>
            </h2>
            <p className="mt-6 text-base md:text-lg text-slate-400 leading-relaxed max-w-lg">
              Le marché français de l&rsquo;énergie s&rsquo;est ouvert à la concurrence, et il se
              recompose vite. Les foyers quittent le tarif réglementé pour les offres de marché —
              exactement le terrain où Alternativ se développe.
            </p>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="relative">
              <div className="absolute -inset-5 bg-emerald-400/10 blur-3xl rounded-full pointer-events-none" />
              <div className="relative rounded-[1.75rem] border border-emerald-400/20 overflow-hidden shadow-[0_30px_90px_-40px_rgba(16,185,129,0.4)]">
                <img
                  src={IMG_A}
                  alt="Un conseiller Alternativ conclut un contrat chez un client"
                  data-testid="marche-image"
                  className="w-full h-72 md:h-96 object-cover scale-[1.12]"
                />
              </div>
            </div>
          </Reveal>
        </div>

        <div className="grid sm:grid-cols-3 gap-5">
          {stats.map((s, i) => (
            <Reveal key={s.value} delay={i * 0.08}>
              <div
                data-testid={`marche-stat-${i}`}
                className={`h-full rounded-[1.5rem] border p-7 md:p-8 transition-colors duration-500 ${
                  s.amber
                    ? "border-amber-400/25 bg-amber-400/5 hover:border-amber-400/50"
                    : "border-emerald-400/15 bg-[#0E1713]/70 hover:border-emerald-400/40"
                }`}
              >
                <p
                  className={`font-jbmono font-bold text-3xl md:text-4xl tracking-tight ${
                    s.amber ? "text-amber-300" : "text-emerald-400"
                  }`}
                >
                  {s.value}
                </p>
                <p className="mt-3 text-sm text-slate-400 leading-relaxed">{s.label}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2}>
          <p className="mt-8 text-[11px] text-slate-600 leading-relaxed">
            Sources : Commission de régulation de l&rsquo;énergie (CRE) — Observatoire des marchés
            de détail, données au 31/12/2025.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
